import ApiContainer from './ApiContainer'
import VerofreshHttpAdapter from './VeroFreshHttpAdapter'

const $orm = function (modelName) {
  return ApiContainer.getMapper(modelName)
}

const VueOrm = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install (Vue, options) {
    Vue.prototype.$orm = $orm
  }
}

const VueHttpAdapter = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install (Vue, options) {
    Vue.prototype.$httpAdapter = VerofreshHttpAdapter
  }
}

export {
  $orm,
  VueOrm,
  VueHttpAdapter
}
